module.exports = __webpack_public_path__ + "static/media/it.0a9b4f94.svg";